import React from 'react';
import '../../styles/ExamNotices.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

const notices = [
  {
    title: 'FY BSc Semester I Exam Notice',
    date: 'July 10, 2025',
    description: 'All FY BSc students are hereby informed that the Semester I examination will commence from August 5, 2025.',
    fileLink: '#'
  },
  {
    title: 'SY BSc Semester III Hall Ticket Distribution',
    date: 'July 12, 2025',
    description: 'Hall tickets will be distributed from July 25 at the college office. Bring your college ID card.',
    fileLink: '#'
  },
  {
    title: 'TY BSc Internal Assessment Schedule',
    date: 'July 15, 2025',
    description: 'Internal assessments for TY BSc students will be conducted from August 10–15. Contact your class teacher for more details.',
    fileLink: '#'
  }
];

function ExamNotice() {
  return (
    <div className="exam-notice">
      <Navbar />
      <div className="exam-notice-container fade-in">
        <h2 className="exam-notice-title">📢 Exam Notices</h2>
        <div className="exam-notice-list">
          {notices.map((notice, index) => (
            <div className="exam-notice-card" key={index}>
              <h3>{notice.title}</h3>
              <p className="exam-notice-date">{notice.date}</p>
              <p>{notice.description}</p>
              <a href={notice.fileLink} target="_blank" rel="noopener noreferrer" className="exam-notice-button">
                View Notice
              </a>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ExamNotice;
